import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../../core/services/http.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { AuthService } from '../../../../core/services/auth.service';
import { IndexService } from '../../../services/index.service';

@Component({
    selector: 'app-side-nav',
    templateUrl: './sideNav.component.html',
    styleUrls: ['./sideNav.component.css']
})
export class SideNavComponent implements OnInit {

    allMenu: Object[] = [];
    arrMenu: Array<any>;
    current: string;
    entryMenu: string;

    constructor(
        private router: Router,
        private http: HttpService,
        private auth: AuthService,
        public indexService: IndexService
    ) {
        this.entryMenu = indexService.menu;
    }

    ngOnInit() {
        this.loadMenu();
    }

    loadMenu() {
        this.http.get('api/getMenuList', {}).subscribe(data => {
            this.allMenu = data['body'] || [];
            this.auth.setMyAuths(this.allMenu);
            const menusForIsShow = this.allMenu.filter(item => item['isShow'] === '1');

            // 转为tree
            const arrMenuArr = [];
            menusForIsShow.forEach(item => {
                if (item['parentId'] === '1') {
                    arrMenuArr.push({
                        id: item['id'],
                        parentId: '1',
                        name: item['name'],
                        menuList: []
                    });
                }
            });

            arrMenuArr.forEach(value => {
                menusForIsShow.forEach(item => {
                    if (value['id'] === item['parentId']) {
                        // 获得一级菜单
                        item['subMenus'] = [];
                        value['menuList'].push(item);

                        let flag = false;
                        // 获得二级菜单
                        menusForIsShow.forEach(val => {
                            if (item['id'] === val['parentId']) {
                                item['subMenus'].push(val);
                                if (this.entryMenu === val['href']) {
                                    flag = true;
                                }
                            }
                        });
                        if (flag) {
                            item['isExpanded'] = true;
                        }
                    }
                });
            });

            this.arrMenu = arrMenuArr;
        });
    }

    toggleCategory(categoryItem) {
        categoryItem.isExpanded = !categoryItem.isExpanded;
    }

    navClick(item, event) {
        setTimeout(function () {
            window['changeTableMode']();
        }, 300);
        event.preventDefault();
        this.current = item.href;
        this.router.navigate([item.href || ''], {
            queryParams: { 'date': new Date().getTime() }
        }).catch(err => {
            window.location.reload();
        });
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/sideNav/sideNav.component.ts